module.exports = __webpack_public_path__ + "img/GIF_INTRO.gif";